"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getOptionProperty;

var _isString = _interopRequireDefault(require("lodash/isString"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function getOptionProperty(option, key) {
  if ((0, _isString.default)(option)) {
    return undefined;
  }

  return option[key];
}